import { useCallback } from 'react';
import { FormikValues } from 'formik';

export const useWeeklyDays = (validation: FormikValues) => {
  const handleDayOfWeekChange = useCallback((dayValue: number) => {
    const currentWeeklyDays = validation.values.weeklyDays || [];
    const isSelected = currentWeeklyDays.includes(dayValue);

    let newWeeklyDays;
    if (isSelected) {
      newWeeklyDays = currentWeeklyDays.filter(
        (day: number) => day !== dayValue,
      );
    } else {
      newWeeklyDays = [...currentWeeklyDays, dayValue].sort((a, b) => a - b);
    }

    validation.setFieldValue('weeklyDays', newWeeklyDays);
  }, [validation.values.weeklyDays]);

  const isDaySelected = useCallback((dayValue: number) => {
    const weeklyDays = validation.values.weeklyDays || [];
    return weeklyDays.includes(dayValue);
  }, [validation.values.weeklyDays]);

  return {
    handleDayOfWeekChange,
    isDaySelected,
  };
};
